<div class="container mb-5">
    <div class="row">
        <div class="col">
            <div class="header-full-image" [style.background-image]="'url(' + image + ')'" role="banner" aria-label="Header image">
                <h1 class="title" *ngIf="title">{{title}}</h1>
                <div class="description" *ngIf="description">{{description}}</div>
            </div>
        </div>
    </div>
</div>